import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useLastLocation } from "react-router-last-location";
import ls from "local-storage";
import * as CONFIG from "./_config";
import RV from "simple-react-validator";
import ReCAPTCHA from "react-google-recaptcha";

//import background from "./../../public/assests/images/foodbazaarloginimage.png";

toast.configure();
const axios = require("axios");

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.state = {
      formControls: {
        username: "",
        password: "",
        Captcha: "",
      },
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.Login();
    }
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: value,
      },
    });
    // console.log(this.state.formControls);
  };

  changeNumericHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const isNumValue = !isNaN(value) ? value : "";

    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: isNumValue,
      },
    });
  };

  componentDidMount() {
    if (ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)) {
      window.location.href = "/";
    }
  }

  Login = async (e) => {
    // const { state = {} } = this.props.location;
    // const { prevLocation } = state;

    e.preventDefault();

    if (!this.validator.allValid()) {
      toast.error("Please fill all the fields");
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }

    const data = new FormData();
    data.append("method", "POST");
    //data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/ValidateUser`);

    //eslint-disable-next-line no-lone-blocks
    // {
    // CONFIG.DATA.RSA_SUBDOMAIN === 'brooksgrocery' || CONFIG.DATA.RSA_SUBDOMAIN === 'lowesfoodking'?
    // data.append('apiurl', `https://qaecrs.rsaamerica.com/Services/SSWebRestApi.svc/ValidateUser`)
    //     :

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/ValidateUser`;

    //}

    data.append("UserName", this.state.formControls.username);
    data.append("Password", this.state.formControls.password);
    data.append("DeviceInfo", "");
    data.append("DeviceId", "3"); // 3 = Web
    data.append("CustomerId", "1");
    data.append("MobileOS", "");
    data.append("MobileOSVersion", "");
    data.append("MobileModel", "");
    data.append("DeviceRegistrationId", "1.0.0");

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        console.log("ValidateUser", res.data);
        localStorage.setItem("MemberNumber", res.data.MemberNumber);
        localStorage.setItem("UserDetailId", res.data.UserDetailId);
        localStorage.setItem("UserToken", res.data.UserToken);
        if (res.data.ErrorMesasge.ErrorCode <= 0) {
          toast.error(res.data.ErrorMesasge.ErrorDetails);
        } else {
          // clear previously stored data..
          ls.remove("ClientStores");
          ls.remove("Departments");
          //ls.remove('redirectTo');

          // set fresh data..
          ls.set(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`, res.data);
          ls.set("UserId", res.data.UserId);
          ls.set("UserToken", res.data.UserToken);
          // const redirectTo = ls.get('redirectTo');

          if(CONFIG.DATA.ONLY_COUPONS === true && CONFIG.DATA.RSA_SUBDOMAIN !== "") {
            ls.set("redirectTo",document.location.origin+CONFIG.DATA.BASEPATH)
          }
          console.log("hash", window.location.hash);

          const redirectTo = ls.get("redirectTo");

          if (redirectTo && redirectTo !== "")
            window.location.href = redirectTo;
            // window.location.href = "/";
          else if (CONFIG.DATA.THEME == 2) {
            window.location.href = "/";
          } else {
            window.location.href = "/";
          }
        }
      })
      .catch(function (res) {
        toast.error("Error Notification !");
      });
  };

  EnterkeyEvent = (e) => {
    if (e.key === "Enter") {
      var link = document.getElementById("sign_in_button");
      if (link) link.click();
    }
  };

  showRegister(e) {
    let redirectToPath = window.location.pathname;

    if (window.location.hash !== "")
      redirectToPath = redirectToPath + window.location.hash;

    // console.log(window.location, window.location.hash, redirectToPath);
    // ls.set('redirectTo', redirectToPath);
    this.props.history.push(
      CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION
        ? "/register"
        : "/simple-register"
    );
    return false;
  }

  handleChange = (value) => {
    // console.log("Captcha value:", value);
    this.setState({
      formControls: { ...this.state.formControls, ["Captcha"]: value },
    });
  };

  asyncScriptOnLoad = () => {
    // this.setState({ callback: "called!" });
    // console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };

  render() {
    return (
      <div>
        <div className="main-container full-width pt-2 mt-2  ">
          {CONFIG.DATA.THEME === 2 ? (
            <div>
              {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
                ""
              ) : (
                <section
                  id="apus-breadscrumb"
                  className="breadcrumb-page apus-breadscrumb"
                  style={{ backgroundColor: "#f3ffd9" }}
                >
                  <div className="container">
                    <div className="wrapper-breads">
                      <div className="wrapper-breads-inner">
                        <div className="breadscrumb-inner">
                          <h2 className="bread-title">Login</h2>
                          <ol className="breadcrumb">
                            <li>
                              <a href={CONFIG.DATA.BASEPATH}>Home</a>
                            </li>
                            <li>
                              <span>Login</span>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </div>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <div className="title-breadcrumb-inner">
                  <header className="entry-header">
                    <h1 className="entry-title">Login</h1>
                  </header>
                  <div className="breadcrumbs">
                    <Link to="/">Home</Link>
                    <span className="separator">/</span>
                    <span> Login</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
            <>
              <img
                src="/assets/images/food_bazaar_log_n_image.svg"
                style={{ height: "180px" }}
                alt="Foodbazaar"
              />
            </>
          ) : (
            ""
          )}

          <div className="row">
            <div className="col-md-4 offset-md-4 pt-4">
              {CONFIG.DATA.BACKEND_HOST === "foodbazaar" ? (
                <div className="card">
                  <div className="card-body">
                    <h3 style={{ fontWeight: "400" }}>Login</h3>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="page-content border pt-3">
                <div className="container">
                  <article
                    id="post-22"
                    className="post-22 page type-page status-publish hentry"
                  >
                    <div className="entry-content">
                      <div className="woocommerce">
                        <div className="woocommerce-notices-wrapper"></div>

                        <form method="post" className="login">
                          <p className="form-group form-row form-row-wide">
                            <label htmlFor="username">
                              Username or Email Address{" "}
                              <span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="input-text form-control"
                              name="username"
                              id="username"
                              value={this.state.formControls.username}
                              onChange={this.changeHandler}
                              onKeyUp={this.EnterkeyEvent}
                            />
                            <samp className="text-danger">
                              {this.validator.message(
                                "Username",
                                this.state.formControls.username,
                                `required|email`
                              )}
                            </samp>
                          </p>

                          {CONFIG.DATA.ALLOW_PASSWORD ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesfoodking" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowesmarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessupersave" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lowessignature" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "superiorgrocers" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "market33" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "fiestafoodsamarillo" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "topvaluecostplus" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "pandlcountrymarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN ===
                            "bradfordgeneralstore" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "lagreesfoodstores" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "mcdanielpw" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "kirbyfoods" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "vowellsmarketplace" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "sandssupermarket" ||
                          CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw" ? (
                            <p className="form-group form-row form-row-wide">
                              <label htmlFor="password">
                                Password <span className="required">*</span>
                              </label>
                              <input
                                className="input-text form-control"
                                type="password"
                                name="password"
                                id="password"
                                value={this.state.formControls.password}
                                onChange={this.changeHandler}
                                onKeyUp={this.EnterkeyEvent}
                                // pattern="[0-9]*" inputMode="numeric"
                                maxLength="12"
                              />
                              <samp className="text-danger">
                                {this.validator.message(
                                  "Password",
                                  this.state.formControls.password,
                                  `required`
                                )}
                              </samp>
                              <input
                                type="hidden"
                                className="input-text form-control"
                                id="loginpage"
                                name="loginpage"
                                value="loginpage"
                              />
                            </p>
                          ) : (
                            <p className="form-group form-row form-row-wide">
                              <label htmlFor="password">
                                PIN (4 digit number){" "}
                                <span className="required">*</span>
                              </label>
                              <input
                                className="input-text form-control"
                                type="password"
                                name="password"
                                id="password"
                                value={this.state.formControls.password}
                                onChange={this.changeNumericHandler}
                                onKeyUp={this.EnterkeyEvent}
                                pattern="[0-9]*"
                                inputMode="numeric"
                                maxLength="4"
                              />
                              <samp className="text-danger">
                                {this.validator.message(
                                  "Pin",
                                  this.state.formControls.password,
                                  `required|numeric`
                                )}
                              </samp>
                              <input
                                type="hidden"
                                className="input-text form-control"
                                id="loginpage"
                                name="loginpage"
                                value="loginpage"
                              />
                            </p>
                          )}

                          <div className="form-group form-row">
                            <div className="form-group clearfix"></div>
                            <div className="ReCAPTCHA">
                              <ReCAPTCHA
                                style={{ display: "block" }}
                                theme="light"
                                sitekey="6LebzrYUAAAAAIo_0vP7bjbtzzBTKNlC4UvyEGKU"
                                onChange={this.handleChange}
                                asyncScriptOnLoad={this.asyncScriptOnLoad}
                              />

                              <p className="text-danger text-center">
                                {this.validator.message(
                                  "captcha",
                                  this.state.formControls.Captcha,
                                  "required"
                                )}
                              </p>
                              <br />
                            </div>
                            <input
                              onClick={(e) => {
                                this.Login(e);
                              }}
                              type="button"
                              id="sign_in_button"
                              className="btn btn-theme btn-block woocommerce-Button button"
                              name="login"
                              value="login"
                            />
                          </div>
                          <p className="woocommerce-LostPassword lost_password">
                            OR
                          </p>
                          <p className="woocommerce-LostPassword lost_password">
                            <Link to="/forget-pin" className="float-left ml-5">
                              {CONFIG.DATA.ALLOW_PASSWORD ||
                              CONFIG.DATA.RSA_SUBDOMAIN ===
                                "vowellsmarketplace" ||
                              CONFIG.DATA.RSA_SUBDOMAIN ===
                                "sandssupermarket" ||
                              CONFIG.DATA.RSA_SUBDOMAIN === "bakerfoodspw"
                                ? "Forgot Password"
                                : "Forgot Pin?"}
                            </Link>

                            <Link
                              to="#"
                              onClick={(e) => {
                                this.showRegister(e);
                              }}
                              className="float-right mr-5"
                            >
                              Create an Account
                            </Link>
                          </p>
                        </form>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Login;
